import { useBackEvolution } from "../http-evolution";

export class EvolutionService {
	constructor() {}
	axiosInstance = useBackEvolution();

	async getStatus() {
		const response = await this.axiosInstance.get('/instance/connectionState/inovacao');
		return { ...response };
	}

	async getQrCode() {
		const response = await this.axiosInstance.get('/instance/connect/inovacao');
		return { ...response };
	}

	async logout() {
		await this.axiosInstance.delete('/instance/logout/inovacao');
	}
}